// @flow
/** @jsx h */
import { h } from 'preact';
import { styled } from 'goober';
import SaCustomButton from '../SaCustomButton';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../../storeProviders/salesAppStore';

const ModalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    margin-top: 48px;

    span {
      color: #885a00;
    }
  }

  .subText {
    max-width: 355px;
    font-weight: 500;
    align-self: center;
    font-size: 14px;
    line-height: 17px;
    margin-top: 34px;
    color: #6c6c6c;
  }
`;

const UserEligibilityInfo = () => {
  const salesDispatch = useSalesDispatchContext();
  const salesState = useSalesContext();
  const { bottomSheetData, isPreCheckEligibilityDone } = salesState || {};
  const {
    mainTitle,
    subTitle,
    secondaryText,
    primaryText,
    btnName,
    textColor,
  } = bottomSheetData || {};

  const closeHandler = () => {
    salesDispatch({
      type: 'STORE_STATE',
      payload: {
        bottomSheetConfig: {
          showOverlay: false,
          moduleName: null,
        },
        bottomSheetData: {
          mainTitle: null,
          subTitle: null,
          primaryText: null,
          secondaryText: null,
          btnName: null,
        },
      },
    });
  };

  return (
    <ModalContainer>
      <div className='title'>
        {mainTitle} <br />
        <span style={{ color: textColor }}> {subTitle}</span>
      </div>
      <div className='subText'>
        {primaryText}
        <br />
        <br />
        {secondaryText}
      </div>
      <div style={{ marginTop: '66px', marginBottom: '27px' }}>
        <SaCustomButton id='sa-app-btn' onClick={closeHandler} name={btnName} />
      </div>
    </ModalContainer>
  );
};

export default UserEligibilityInfo;



// WEBPACK FOOTER //
// ./components/salesApp/common/UserEligibilityInfo.js